// @flow

import type { StoreResourceDef } from 'app/core/types'

export const personAttributes: StoreResourceDef<> = {
  resourceType: 'personAttributes',
}
